import React from 'react';
import { useTranslation } from 'react-i18next';
import { Input, Select } from '@components';

interface SearchAndFiltersProps {
  searchTerm: string;
  onSearchChange: (value: string) => void;
  statusFilter: string;
  onStatusFilterChange: (value: string) => void;
}

export const SearchAndFilters: React.FC<SearchAndFiltersProps> = ({
  searchTerm,
  onSearchChange,
  statusFilter,
  onStatusFilterChange,
}) => {
  const { t } = useTranslation();
  return (
    <div className="flex flex-col sm:flex-row gap-4 mb-6">
      <div className="w-full sm:w-80">
        <Input
          type="text"
          placeholder={t('phoneNumbers.searchPhoneNumbers')}
          value={searchTerm}
          onChange={e => onSearchChange(e.target.value)}
          className="h-10"
        />
      </div>

      <div className="flex gap-4">
        <div className="w-48">
          <Select
            value={statusFilter}
            onChange={value => onStatusFilterChange(Array.isArray(value) ? value[0] : value)}
            options={[
              { value: '', label: t('phoneNumbers.allStatus') },
              { value: 'in_use', label: t('phoneNumbers.inUse') },
              { value: 'not_in_use', label: t('phoneNumbers.notInUse') },
            ]}
            className="h-10"
          />
        </div>
      </div>
    </div>
  );
};
